import { MenuItem } from '@chakra-ui/react'
import { FC } from 'react'
import { GrDocumentCsv } from 'react-icons/gr'

import useStoretBudget from '@hook/budget/use-store'
import useTools from '@hook/shared/use-tools'

import { ILayoutToolsExportAction } from '@base/@types/components/Layout/Tools'
const ActionExcelStoreAnalitcExport: FC<ILayoutToolsExportAction> = () => {
  const { isDisabled } = useTools()
  const { exportDataAnalitc } = useStoretBudget()
  return (
    <MenuItem
      p="2px 12px"
      fontSize="sm"
      bgColor="white"
      _hover={{ bg: 'gray.400' }}
      isDisabled={isDisabled}
      onClick={exportDataAnalitc}
      icon={<GrDocumentCsv />}
    >
      Exportar Analitico para CSV
    </MenuItem>
  )
}

export default ActionExcelStoreAnalitcExport
